/**
 * @file card/Meta
 * @author chenyaqiu
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import { getAction } from './Card';
;
const Meta = props => (<ConfigConsumer>
        {({ getPrefixCls }) => {
        const { prefixCls: customizePrefixCls, className, title, content, description, actions } = props, others = __rest(props, ["prefixCls", "className", "title", "content", "description", "actions"]);
        const prefixCls = getPrefixCls('card', customizePrefixCls);
        const classString = classNames(`${prefixCls}-meta-wrap`, className);
        const titleDom = title ? (<div className={`${prefixCls}-meta-title`}>{title}</div>) : null;
        const contentDom = content ? (<div className={`${prefixCls}-meta-content-detail`}>{content}</div>) : null;
        const MetaContent = titleDom || contentDom ? (<div className={`${prefixCls}-meta-content`}>
                    {titleDom}
                    {contentDom}
                </div>) : null;
        const MetaActions = actions && actions.length ? (<ul className={`${prefixCls}-meta-footer-actions`}>{getAction(actions)}</ul>) : null;
        return (<div className={classString} {...others}>
                    {MetaContent}
                    <div className={`${prefixCls}-meta-footer`}>
                        <div className={`${prefixCls}-meta-footer-desc`}>
                            {description}
                        </div>
                        {MetaActions}
                    </div>
                </div>);
    }}
    </ConfigConsumer>);
export default Meta;
